import { render } from "./editMeta.vue?vue&type=template&id=47147485&scoped=true"
import script from "./editMeta.vue?vue&type=script&lang=js"
export * from "./editMeta.vue?vue&type=script&lang=js"

import "./editMeta.vue?vue&type=style&index=0&id=47147485&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47147485"]])

export default __exports__